export default "__VITE_ASSET__oOtSsAgf__"